module.exports = __webpack_public_path__ + "img/nepal-logo-icon.0e797a94.png";